import { useCallback, useState } from 'react'
import { API } from 'src/utils/interceptor'
import Sentry from 'src/utils/sentry'

export const fetchProductPriceAudit = async productId => {
  const product = await API.get('api', `product/${productId}`)
  return {
    product,
    priceHistory: Array.isArray(product?.priceHistory)
      ? product.priceHistory
      : [],
  }
}

export const useProductPriceAudit = () => {
  const [visible, setVisible] = useState(false)
  const [product, setProduct] = useState(null)
  const [priceHistory, setPriceHistory] = useState([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const openAudit = useCallback(async productRow => {
    const productId = productRow?._id || productRow?.id
    if (!productId) return

    setProduct(productRow)
    setPriceHistory([])
    setError(null)
    setVisible(true)
    setLoading(true)

    try {
      const { product: fetchedProduct, priceHistory: history } =
        await fetchProductPriceAudit(productId)
      setProduct(fetchedProduct)
      setPriceHistory(history)
    } catch (e) {
      console.error(e)
      Sentry.captureException(e)
      setError('Could not load price history. Please try again.')
    } finally {
      setLoading(false)
    }
  }, [])

  const closeAudit = useCallback(() => {
    setVisible(false)
    setProduct(null)
    setPriceHistory([])
    setError(null)
    setLoading(false)
  }, [])

  return {
    visible,
    product,
    priceHistory,
    loading,
    error,
    openAudit,
    closeAudit,
  }
}
